import State from "../../Player/states/states.js";

import { EnemyStateConfig } from "../../GameConfig/EnemyConfig.js";
import Bullet from "../weapons/bullet.js";

export default class Death extends State {
  constructor(enemy, img_src, maxFrame) {
    super(EnemyStateConfig.DEATH);
    this.enemy = enemy;
    this.imgSrc = img_src;
    this.maxFrame = maxFrame;
  }

  enter() {
    this.enemy.burst.image.src = "";

    this.enemy.image.src = this.imgSrc;
    this.enemy.maxFrame = this.maxFrame;
    this.enemy.frameX = 0;
    this.enemy.isColliding = false;
  }

  update() {
    if (this.enemy.frameX >= this.enemy.maxFrame) {
      this.enemy.markedForDeletion = true;
    }
  }
}
